import { useCurrentAccount } from "@/features/accounts/hooks/useCurrentAccount";
import { Menu } from "lucide-react";
import { useLocation } from "react-router-dom";

const SECTION_LABELS: Record<string, string> = {
  "/app/hato": "Hato",
  "/app/lotes": "Lotes",
  "/app/costos": "Costos",
  "/app/depreciacion": "Depreciación",
  "/app/reportes": "Reportes",
  "/app/ajustes": "Ajustes",
};

function usePageTitle(): string {
  const { pathname } = useLocation();
  const base = `/${pathname.split("/").slice(1, 3).join("/")}`;
  return SECTION_LABELS[base] ?? "Hato";
}

type Props = {
  onMenuClick: () => void;
};

export function AppTopbar({ onMenuClick }: Props) {
  const { currentAccount } = useCurrentAccount();
  const pageTitle = usePageTitle();

  return (
    <div className="flex items-center gap-3.5 border-app-border border-b bg-app-surface px-4 py-3 md:px-6">
      <button
        type="button"
        aria-label="Abrir menú"
        onClick={onMenuClick}
        className="grid h-8 w-8 place-items-center rounded-md border border-app-border text-app-ink-2 hover:bg-app-surface-2 md:hidden"
      >
        <Menu size={16} />
      </button>

      <div className="flex items-center gap-1.5 font-medium text-[13px] text-app-ink-2">
        <span>{currentAccount?.name ?? "..."}</span>
        <span className="text-app-ink-3">/</span>
        <span className="text-app-ink-1">{pageTitle}</span>
      </div>
    </div>
  );
}
